import {FormGroup, ValidationErrors, Validator} from '@angular/forms';

/**
 * Validates values of all fields in the group.
 * All values are required
 * Also validates whether control group is empty if requiredMsg is provided
 *
 */
export class MultiInputRequiredValidator implements Validator {

    private msg: string;
    private requiredMsg: string;
    private excludePrefix: string;

    constructor(msg: string, requiredMsg: string, excludePrefix: string) {
        this.msg = msg;
        this.requiredMsg = requiredMsg;
        this.excludePrefix = excludePrefix;
    }

    /**
     *
     * @param {string} msg
     * @param {string} excludePrefix    - Do not validate controls with key starting with excludePrefix
     * @returns {(control: FormGroup) => (ValidationErrors | null)}
     */
    public static validator(msg: string, requiredMsg: string, excludePrefix?: string) {
        const validator = new MultiInputRequiredValidator(msg, requiredMsg, excludePrefix);
        return (control: FormGroup): ValidationErrors | null => validator.validate(control);
    }

    validate(control: FormGroup): ValidationErrors | null {

        let error = false;
        const keys = Object.keys(control.controls);
        let realControlNum = 0;
        keys.forEach(key => {
            const c = control.controls[key];
            // check and count only controls without excludePrefix prefix
            if (!this.excludePrefix || !key.startsWith(this.excludePrefix)) {
                realControlNum++;
                if ((c.value || '').length == 0) {
                    // console.log('MultiInputRequiredValidator:', key);
                    error = true;
                }
            }
        });
        if (!realControlNum && !error && this.requiredMsg) {
            return {multiInputRequired: this.requiredMsg};
        }

        return error ? {multiInputRequired: this.msg} : null;
    }
}
